module.exports = __webpack_public_path__ + "static/img/ce-qeury-logo.08276dbc.png";